import styled from '@emotion/styled';

const QrCode = styled('img')({
  marginLeft: 'auto',
  marginRight: 'auto',
  marginBottom: 24,
});

export default QrCode;
